<template>
  <div class="sessions">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-md-12 d-block d-sm-flex justify-content-between align-items-center">
            <h1 class="fw-600 fs-24 mb-0">Sessões</h1>
            <button class="btn btn-blue my-3 my-sm-0" data-toggle="modal" @click="openCreateModal()">
              Nova Sessão
            </button>
          </div>
        </div>
        <div class="table-responsive mt-1">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Ordem</th>
                <th>Nome</th>
                <th>Url</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="session in sessions.data" :key="session.id">
                <td class="align-middle body-table">
                    {{ session.id }}
                </td>
                <td class="align-middle body-table">
                    {{ session.order }}
                </td>
                <th class="align-middle body-table">
                    {{ session.title }}
                </th>
                <td class="align-middle body-table">
                  {{ (session.url) ? session.url : '-' }}
                </td>
                <td class="align-middle body-table">
                  <button class="btn mr-2" data-toggle="modal" @click="openUpdateModal(session)">
                    <i class="far fa-edit"></i>
                  </button>
                  <button class="btn" data-toggle="modal" @click="openDeleteModal(session)">
                    <i class="fas fa-times text-danger"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <LoadingComponent :loading="loading || !sessions.data" />

    <!-- Register Modal -->
    <div class="modal fade" id="CreateModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-w" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ (session.id ? 'Editar sessão' : 'Cadastrar sessão')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col-12">
                    <label class="form-control-label">Nome:</label>
                    <input type="text" class="form-control" v-model="session.title" required>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12">
                    <label class="form-control-label">Descrição:</label>
                    <input type="text" class="form-control" v-model="session.description" required>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col">
                    <label class="form-control-label">Posição:</label>
                    <input type="number" class="form-control" v-model="session.order" required>
                  </div>
                  <div class="col">
                    <label class="form-control-label">Link de Destino:</label>
                    <input type="text" class="form-control" v-model="session.url" required>
                  </div>
                  <div class="col">
                    <label class="form-control-label">Relação:</label>
                    <select class="form-control" v-model="session.relation" required>
                      <option :value="null"> - Selecione - </option>/
                      <option :value="1">Produto</option>
                      <option :value="2">Banner</option>
                      <option :value="3">Blog</option>
                      <!-- <option :value="'blog'">Blog</option> -->
                    </select>
                  </div>
                </div>
                <!-- Produto -->
                <div class="row mt-4" v-if="session.relation == 1">
                  <div class="col-md-12 my-3">
                    <p class="py-0 my-0">Produtos</p>
                  </div>
                  <div v-for="product in products" :key="product.id" class="col-md">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" v-model="session.products_ids" :value="product.id" :id="'optionProduct'+product.id" class="form-check-input">{{ product.title }}
                      </label>
                    </div>
                  </div>
                </div>
                <!-- Blog -->
                <div class="row mt-4" v-if="session.relation == 3">
                  <div class="col-md-12 my-3">
                    <p class="py-0 my-0">Matérias do Blog</p>
                  </div>
                  <div v-for="article in articles" :key="article.id" class="col-md">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" :disabled="isDisabled(article.id)" v-model="session.articles_ids" :value="article.id" :id="'optionArticle'+article.id" class="form-check-input">{{ article.title }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row pt-4" v-if="session.relation == 2">
                  <!-- Botão para adicionar grupo -->
                  <div class="col-12">
                    <button class="btn btn-info px-2 py-2" @click="addGroup">
                      Montar Grupo
                    </button>
                  </div>

                  <draggable
                    v-model="session.groups"
                    item-key="groupId"
                    @start="drag = true"
                    @end="drag = false, updateGroupSequence()"
                    handle=".handle"
                    class="w-100"
                  >
                    <div
                      v-for="(group, groupIndex) in session.groups"
                      :key="group.groupId"
                      class="col-12"
                      style="margin-top: 20px;"
                    >
                      <details
                        :ref="el => setDetailsRef(group.groupId, el)"
                        @toggle="onToggle(group.groupId)"
                        :class="{'border rounded': openedGroups[group.groupId]}"
                      >
                        <summary
                          :class="[
                            !openedGroups[group.groupId] ? 'border' : '',
                            'btn rounded px-3 w-100 d-flex align-items-center justify-content-between handle gap-2',
                            drag ? 'grabbing' : 'grab'
                          ]"
                        >
                          <span class="grab py-2 w-100 text-left">Grupo {{ groupIndex + 1 }}</span>
                          <button type="button" @click.stop="removeGroup(groupIndex)" class="btn btn-none">
                            <i class="fas fa-trash-alt text-danger pointer trash-alt"></i>
                          </button>
                          <i v-if="openedGroups[group.groupId]" class="fas fa-chevron-up pointer"></i>
                          <i v-else class="fas fa-chevron-down pointer"></i>
                        </summary>

                        <div
                          v-for="image in group.images"
                          :key="image.device"
                          class="row align-items-center justify-content-center mx-0 mt-5"
                        >
                          <div v-if="!image.cropping" class="col-md-2 pt-3 px-0">
                            <div class="position-relative" v-if="!image.url">
                              <input
                                type="file"
                                @change="uploadImage($event, group.groupId, image.device)"
                                accept="image/*"
                                class="hidden"
                                id="file-upload"
                              >
                              <label
                                for="file-upload"
                                class="
                                  border rounded p-2 d-flex flex-column align-items-center justify-content-center
                                  w-100 h-100 cursor-pointer bg-light hover-bg-light-hover
                                  text-center text-muted
                                "
                                style="min-height: 120px;"
                              >
                                <i class="fas fa-upload fs-4 mb-2"></i>
                                <small>Clique para enviar</small>
                              </label>
                            </div>
                            <div class="position-relative">
                              <img v-if="image.url" :src="image.url" class="w-100 mb-2 pl-2" alt=""/>
                              <button
                                v-if="image.url"
                                class="btn image-btn"
                                @click="deleteImage(group.groupId, image.device)"
                              >
                                <i class="fas fa-trash-alt pos text-danger"></i>
                              </button>
                            </div>
                          </div>

                          <div v-if="image.cropping" class="col-md-2 mt-3 pr-0">
                            <Cropper
                              :restrictions="pixelsRestriction"
                              :src="image.url"
                              :ref="`cropper-${group.groupId}-${image.device}`"
                            />
                            <button
                              class="btn btn-warning text-uppercase px-3 py-3"
                              @click="crop(group.groupId, image.device)"
                            >
                              CORTAR
                            </button>
                          </div>
                          <div class="col-md-2 pr-0 d-flex align-items-center gap-2 justify-content-center">
                            <select class="form-control" v-model="image.device" required>
                              <option :value="null"> - Dispositivo - </option>
                              <option :value="1">Mobile</option>
                              <option :value="2">Desktop</option>
                            </select>
                          </div>
                          <div class="col-md d-flex pr-0 align-items-center gap-2 justify-content-center">
                            <input
                              type="text"
                              class="form-control"
                              v-model="image.link"
                              placeholder="Link de Redirecionamento"
                            />
                          </div>
                          <div class="col-md d-flex align-items-center gap-2 justify-content-center">
                            <input
                              type="text"
                              class="form-control"
                              v-model="image.alt"
                              placeholder="Descrição (Alt)"
                            />
                          </div>
                        </div>
                      </details>
                    </div>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">Fechar</button>
            <button type="button" class="btn btn-success" @click="updateSession()" v-if="session.id">Editar sessão</button>
            <button type="button" class="btn btn-success" @click="addSession()" v-else>Cadastrar sessão</button>
          </div>
        </div>
      </div>
    </div>
    <!-- DELETE MODAL -->
      <div class="modal fade" id="openDeleteModal" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h3 class="modal-title" id="exampleModalLabel">Excluir sessão</h3>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      Deseja excluir o sessão?
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-dark" data-dismiss="modal">Fechar</button>
                      <button type="button" class="btn btn-danger" @click="deleteSession()">Excluir</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import LoadingComponent from '../../components/layout/LoadingComponent'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import draggable from 'vuedraggable'

export default {

  name: 'IndexSessionsPage',

  components: {
    LoadingComponent,
    Cropper,
    draggable
  },

  computed: mapState({
    products: state => state.params.data.products,
    sessions: state => state.sessions.data,
    loading: state => state.sessions.loading,
    articles: state => state.articles.data.data
  }),

  data: function () {
    return {
      session: {
        description: null,
        slug: null,
        parent_id: null,
        coupon_id: null,
        banners: [],
        groups: []
      },
      destroy_session: null,
      article: {
        title: null
      },
      destroy_blog: null,
      img: null,
      errorImage: null,
      openedGroups: {},
      detailsRefs: {},
      drag: false
    }
  },

  methods: {

    ...mapActions('params', [
      'getProducts'
    ]),

    ...mapActions('articles', {
      getArticles: 'index'
    }),

    ...mapActions('sessions', [
      'index',
      'store',
      'update',
      'destroy'
    ]),

    addSession: function () {
      this.store(this.session)
      $('#CreateModal').modal('hide')
    },

    openCreateModal: function () {
      this.getProducts()
      this.getArticles(1)
      this.session = {
        title: null,
        description: null,
        url: null,
        order: null,
        relation: null,
        products_ids: [],
        articles_ids: [],
        banners: [],
        groups: []
      }
      $('#CreateModal').modal()
    },

    openUpdateModal: function (session) {
      this.getProducts()
      this.getArticles(1)
      this.session = { ...session }
      $('#CreateModal').modal()
    },

    openDeleteModal: function (session) {
      this.destroy_session = session
      $('#openDeleteModal').modal()
    },

    updateSession: function () {
      this.update({ id: this.session.id, data: this.session })
      $('#CreateModal').modal('hide')
    },

    deleteSession: function () {
      this.destroy(this.destroy_session.id)
      $('#openDeleteModal').modal('hide')
    },

    isDisabled (articleId) {
      // Verifica se o limite foi atingido e o item atual não está selecionado
      return this.session.articles_ids.length >= 10 && !this.session.articles_ids.includes(articleId)
    },

    pixelsRestriction ({ minWidth, minHeight, maxWidth, maxHeight, imageWidth, imageHeight }) {
      this.errorImage = null

      // se a imagem for menor que 200px
      if (imageHeight < 200 || imageWidth < 200) {
        this.errorImage = 'Essa imagem é muito pequena. Para melhor visualização do produto, opte por imagens com dimensões superiores a 600x600 px'
        return false

      // se a imagem for maior que 200px e menor que 600px
      } else if (imageHeight < 600 || imageWidth < 600) {
        this.errorImage = 'Dica: Para melhor visualização do produto, opte por imagens com dimensões superiores a 600px x 600px'
        return {
          minWidth: minWidth,
          minHeight: minHeight,
          maxWidth: Math.min(imageWidth, maxWidth),
          maxHeight: Math.min(imageHeight, maxHeight)
        }
      }
    },

    uploadImage (event, groupId, device) {
      const file = event.target.files[0]
      if (!file) return

      const reader = new FileReader()
      reader.onload = e => {
        const group = this.session.groups.find(g => g.groupId === groupId)

        if (group) {
          const banner = group.images.find(i => i.device === device)
          banner.url = e.target.result
          banner.cropping = true
        }
      }
      reader.readAsDataURL(file)
    },

    crop (groupId, device) {
      const refName = `cropper-${groupId}-${device}`
      const cropper = this.$refs[refName]

      console.log(groupId, device)

      const cropperInstance = Array.isArray(cropper) ? cropper[0] : cropper

      if (!cropperInstance || typeof cropperInstance.getResult !== 'function') {
        console.error(`Cropper não disponível para ref "${refName}"`)
        return
      }

      const { coordinates, canvas } = cropperInstance.getResult()

      if (canvas) {
        const group = this.session.groups.find(g => g.groupId === groupId)
        if (group) {
          const banner = group.images.find(i => i.device === device)
          if (banner) {
            banner.url = canvas.toDataURL()
            banner.cropping = false
            banner.coordinates = coordinates
          }
        }
      }
    },

    deleteImage (groupId, device) {
      const group = this.session.groups.find(g => g.groupId === groupId)
      if (group) {
        const banner = group.images.find(i => i.device === device)
        banner.url = null
        banner.cropping = false
      }
    },

    addGroup () {
      const groupId = crypto.randomUUID()

      const newGroup = {
        groupId,
        images: [
          { device: 1, link: '', url: null, cropping: false }, // Mobile
          { device: 2, link: '', url: null, cropping: false } // Desktop
        ]
      }

      this.session.groups.push(newGroup)
    },

    setDetailsRef (groupId, el) {
      if (el) this.detailsRefs[groupId] = el
    },

    onToggle (groupId) {
      const detailsEl = this.detailsRefs[groupId]
      if (detailsEl) {
        this.$set(this.openedGroups, groupId, detailsEl.open)
      }
    },

    updateGroupSequence () {
      this.session.groups.forEach((group, index) => {
        group.sequence = index + 1
      })

      this.$toasted.success('Sequencia alterada com sucesso')
    },

    removeGroup (groupIndex) {
      this.session.groups.splice(groupIndex, 1)
    }
  },

  mounted () {
    this.index({
      page: 1,
      name: null
    })
  }

}

</script>
<style scoped>
.modal-w {
  width: 70vw !important;
  max-width: 70vw !important;
}
.no-drag {
  pointer-events: none; /* Impede interações com o item */
  opacity: 0.5; /* Torna o item visualmente inativo */
}
.image-btn {
  position: absolute;
  top: 0;
  right: 0px;
}
details:focus, details:focus-visible,
summary:focus, summary:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
.trash-alt {
  opacity: 0;
  transition: all 0.2s ease;
}
summary:hover .trash-alt {
  opacity: 1;
}
</style>
